export default __webpack_public_path__ + "ef34f0d3e04f4625dc265771bce7a5f6.png";